// extracted by mini-css-extract-plugin
export default {"modalText":"ConfirmText_modalText__jlWmL","modalTextOpen":"ConfirmText_modalTextOpen__1ituJ","buttons":"ConfirmText_buttons__sNz4a"};